










































































import AddProductItem_Step1 from '@/components/add-flows/product/AddProductItem-Step1.vue';
import AddProductItem_Step2 from '@/components/add-flows/product/AddProductItem-Step2.vue';
import AddMediaItem_Step1 from '@/components/add-flows/media/AddMediaItem-Step1.vue';
import AddMediaItem_Step2 from '@/components/add-flows/media/AddMediaItem-Step2.vue';
import AddPlaceItem_Step1 from '@/components/add-flows/place/AddPlaceItem-Step1.vue';
import AddPlaceItem_Step2 from '@/components/add-flows/place/AddPlaceItem-Step2.vue';
import AddGenericItem_Step2 from '@/components/add-flows/generic/AddGenericItem-Step2.vue';
import AddItem_Step3 from '@/components/add-flows/AddItem-Step3.vue';
import AddItem_Step4 from '@/components/add-flows/AddItem-Step4.vue';

import axios from 'axios';

import { ProductItem } from '@/models/items/product-item-model';
import { PlaceItem } from '@/models/items/place-item-model';
import { GenericItem } from '@/models/items/generic-item-model';
import { ListModel } from '@/models/list-model';
import {
  AbstractItemModel,
  ItemType
} from '@/models/items/abstract-item-model';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    AddProductItem_Step1,
    AddProductItem_Step2,
    AddMediaItem_Step1,
    AddMediaItem_Step2,
    AddPlaceItem_Step1,
    AddPlaceItem_Step2,
    AddGenericItem_Step2,
    AddItem_Step3,
    AddItem_Step4
  }
})
export default class AddEditItem extends Vue {
  @Prop(Boolean) public editMode: boolean;
  @Prop(Boolean) public copyMode: boolean;
  @Prop(GenericItem) public item: GenericItem;
  @Prop(ListModel) public list?: ListModel;

  mutableItem: GenericItem = this.item;

  public step: number = 1;
  public initialStep: number = 1;
  public lastStepData: any = {};

  public created() {
    if (this.copyMode) {
      // just to make sure we don't go overwrite the original item
      this.mutableItem.id = 'xxxx';
      this.mutableItem.description = '';
      this.mutableItem.timeAdded = undefined;
    }

    if (this.editMode || this.copyMode || this.item.isGeneric) {
      this.step = 2;
      this.initialStep = 2;
    }
  }

  public goToNextStep(evt: any) {
    const { item } = evt;
    const self = this;

    this.step += 1;
    this.mutableItem = item;
    this.lastStepData = evt;
  }

  public goToPrevStep() {
    this.step -= 1;
  }
}
